import { IQuoteFilters, QuotesState } from "../state/quotesState";
import * as quoteAPIUtil from "../../util/quote/quoteAPIUtil";
import * as catalogueAPIUtil from "../../util/catalogue/catalogueAPIUtil";
import { User } from "../../models/User";
import { IQuote, IQuoteItem } from "../../interfaces/IQuote";

import { IQuotesResponse } from "../../interfaces/IQuotesResponse";
import MQuoteListItem from "../../models/MQuoteListItem";
import MQuoteItem from "../../models/MQuoteItem";
import { MArtwork } from "../../models/MArtwork";
import { IArtwork } from "../../interfaces/IArtwork";
export const RECEIVE_QUOTE_LIST = "[Quotes] RECEIVE_QUOTE_LIST";
export const RECEIVE_QUOTE = "[Quotes List] RECEIVE_QUOTE";
export const FETCH_ERROR = "[Quotes List] FETCH_ERROR";
export const IS_LOADING = "[Quotes List] IS_LOADING";
export const CLEAR_FILTERS = "[Quote] CLEAR_FILTERS";
export const UPDATE_FILTERS = "[Quote] UPDATE_FILTERS";
export const RECEIVE_QUOTE_ITEM = "[Quote] RECEIVE_QUOTE_ITEM";
export const RECEIVE_QUOTE_CONTENT = "[Quote] RECEIVE_QUOTE_CONTENT";
export const RECEIVE_QUOTE_ITEMS = "[Quote Items] RECEIVE_QUOTE_ITEMS";
export const RECEIVE_QUOTE_ITEM_DETAILS = "[Quote Item Details] RECEIVE_QUOTE_ITEM_DETAILS";
export const RECEIVE_QUOTE_ITEM_ROWS = "[Quote Item Rows] RECEIVE_QUOTE_ITEM_ROWS";
export const CLEAR_QUOTE_DETAIL_DATA = "[Quote Data] CLEAR_QUOTE_DETAIL_DATA";
export const RECEIVE_QUOTE_ITEM_ROW_DECO_DETAILS = "[Quote Item Deco Data] RECEIVE_QUOTE_ITEM_ROW_DECO_DETAILS";
export const RECEIVE_QUOTE_ITEM_ROW_DETAILS = "[Quote Item Row Data] RECEIVE_QUOTE_ITEM_ROW_DETAILS";
export const RECEIVE_PRODUCT = "[Product Details] RECEIVE_PRODUCT";
export const SET_SAVE_BTN = "[Set Savebtn] SET_SAVE_BTN";
export const SET_ITEMS_SELECTED = "[Quote items selected] SET_ITEMS_SELECTED";
export const IS_LOADER = "[Loader Only] IS_LOADER";
export const RECEIVE_QUOTE_ITEM_ROWS_CHARGES = "[Row Charges] RECEIVE_QUOTE_ITEM_ROWS_CHARGES";
export const RECEIVE_QUOTE_DECORATION_LOCATIONS = "[Quote locations] RECEIVE_QUOTE_DECORATION_LOCATIONS";
export const RECEIVE_QARTWORKS_LIST = "[Quote artwork] RECEIVE_QARTWORKS_LIST";
export const RECEIVE_QUOTE_DECORATORS_VENDORS_LIST = "[Quote decoration vendors list] RECEIVE_QUOTE_DECORATORS_VENDORS_LIST";
export const RECEIVE_QUOTE_DECORATION_TYPE = "[Quote decoration type list] RECEIVE_QUOTE_DECORATION_TYPE";
export const RECEIVE_QUOTE_DECORATORS_TYPE_LIST = "[Quote decorators type list] RECEIVE_QUOTE_DECORATORS_TYPE_LIST";

export const receiveQuotes = (quotes: IQuote[], count: number, meta: {}) => ({
    type: RECEIVE_QUOTE,
    payload: quotes,
    count,
    meta
});

export const receiveQuote = (quote: IQuote) => ({
    type: RECEIVE_QUOTE_ITEM,
    payload: quote
});

export const receiveQuoteContent = (quote) => ({
    type: RECEIVE_QUOTE_CONTENT,
    payload: quote
});

export const receiveDecorationLocations = (types: []) => ({
    type: RECEIVE_QUOTE_DECORATION_LOCATIONS,
    payload: types,
});
export const receiveQuoteItems = (quote: IQuoteItem[]) => ({
    type: RECEIVE_QUOTE_ITEMS,
    payload: quote
});
export const fetchDecorationLocations = () => dispatch => catalogueAPIUtil.fetchDecorationLocations()
    .then(res => {
        dispatch(receiveDecorationLocations(res.data))
    }).catch(error => {
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });
export const receiveQuoteItemDetails = (quote) => ({
    type: RECEIVE_QUOTE_ITEM_DETAILS,
    payload: quote
});

export const receiveQuoteItemRows = (quote) => ({
    type: RECEIVE_QUOTE_ITEM_ROWS,
    payload: quote
});
export const receiveQuoteItemRowsCharges = (quote) => ({
    type: RECEIVE_QUOTE_ITEM_ROWS_CHARGES,
    payload: quote
});
export const receiveQuoteItemRowDecoDetails = (quote) => ({
    type: RECEIVE_QUOTE_ITEM_ROW_DECO_DETAILS,
    payload: quote
});
export const receiveQuoteItemRowDetails = (quote) => ({
    type: RECEIVE_QUOTE_ITEM_ROW_DETAILS,
    payload: quote
});
export const receiveProduct = (quote) => ({
    type: RECEIVE_PRODUCT,
    payload: quote
});

export const fetchQuotes = (limit: number = 50, offset: number = 0, order: string = "productName", orient: string = "asc", filters: IQuoteFilters) => dispatch => quoteAPIUtil.fetchQuotes(limit, offset, order, orient, filters)
    .then(res => {
        const catalogueResponse: IQuotesResponse = res.data;
        const catalogueList: IQuote[] = catalogueResponse.data.map(individualCatalogue => {
            return new MQuoteListItem(individualCatalogue);
        });
        let tempQuote = JSON.stringify(catalogueList)
        tempQuote = tempQuote.replace(new RegExp('cdnl.sanmar.com', 'g'), 'cdnm.sanmar.com')
        dispatch(receiveQuotes(JSON.parse(tempQuote), catalogueResponse.meta.page_count, catalogueResponse.meta))
    }).catch(error => {
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });
export const fetchQuote = (id) => dispatch => quoteAPIUtil.fetchQuote(id)
    .then(res => {
        const quotes = res.data.data;
        let tempQuote = JSON.stringify(quotes)
        tempQuote = tempQuote.replace(new RegExp('cdnl.sanmar.com', 'g'), 'cdnm.sanmar.com')
        dispatch(receiveQuote(JSON.parse(tempQuote)))
    }).catch(error => {
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });
export const fetchQuoteItems = (id) => dispatch => quoteAPIUtil.fetchQuoteItems(id)
    .then(res => {
        const quotes = res.data;
        const quotesItems: IQuoteItem[] = quotes.data.filter(quoteItem => {
            if(quoteItem.hide != "" && (quoteItem.price == "" || Number(quoteItem.price) <= 0)){
                return false
            }return true
    }).map(individualCatalogue => {
            return new MQuoteItem(individualCatalogue);
        });
        dispatch(receiveQuoteItems(quotesItems))
    }).catch(error => {
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });
export const fetchQuoteItemDetails = (qid, id) => dispatch => quoteAPIUtil.fetchQuoteItemDetail(qid, id)
    .then(res => {
        const quotes = res.data.data;
        dispatch(receiveQuoteItemDetails(quotes))
    }).catch(error => {
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });
export const fetchQuoteItemRows = (qid, id) => dispatch => quoteAPIUtil.fetchQuoteItemRows(qid, id)
    .then(res => {
        const quotes = res.data.data;
        dispatch(receiveQuoteItemRows(quotes))
    }).catch(error => {
        dispatch(receiveQuoteItemRows([]))
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });
export const fetchQuoteItemRowsCharges = (qid, id) => dispatch => quoteAPIUtil.fetchQuoteItemRowsCharges(qid, id)
    .then(res => {
        const quotes = res.data.data;
        dispatch(receiveQuoteItemRowsCharges(quotes))
    }).catch(error => {
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });
export const fetchQuoteItemRowDecoDetails = (qid, id, row_id) => dispatch => quoteAPIUtil.fetchQuoteItemRowDecoDetail(qid, id, row_id)
    .then(res => {
        const quotes = res.data.data;
        dispatch(receiveQuoteItemRowDecoDetails(quotes))
    }).catch(error => {
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });
export const fetchQuoteItemRowDetails = (qid, id, row_id) => dispatch => quoteAPIUtil.fetchQuoteItemRowDetail(qid, id, row_id)
    .then(res => {
        const quotes = res.data.data;
        dispatch(receiveQuoteItemRowDetails(quotes))
    }).catch(error => {
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });
export const fetchProduct = (id, account_id, qid) => dispatch => catalogueAPIUtil.fetchCatalogue(id, account_id, qid)
    .then(res => {
        const catalogueres = res.data.data;
        dispatch(receiveProduct(catalogueres))
    }).catch(error => {
        dispatch(receiveProduct(null))
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });
export const updateRowItems = (quoteId, Itemid, data, changes, addToast, quoteItem = null, artworkList = null, quoteProductDetails = null) => async dispatch => {
    dispatch(setLoader(true));
    const promises = [];
    const promises_first = [];
    const compareData = (rowData, decorow, oldRowsIDs) => {
        if (rowData.size === decorow.size && rowData.quantity === decorow.quantity && rowData.color === decorow.color && oldRowsIDs.indexOf(rowData.id) === -1) {
            return true
        }
        return false
    }
    let itm = quoteItem.items.filter(itemArray => itemArray.id === Itemid)[0]
    let itmrows = itm.rows;
    data.map(async dataArray => {
        if (dataArray.id != "") {
            promises.push(catalogueAPIUtil.updateRowItem(quoteId, Itemid, dataArray))
            itmrows?.map(itemArray => {
                if (itemArray.id == dataArray.id) {
                    let decoChangedArray = itemArray.decoration;
                    if (decoChangedArray.length > 0) {
                        decoChangedArray = decoChangedArray.map(decoChangedTemp => {
                            let tempDecoData = { ...decoChangedTemp }
                            tempDecoData.quantity = dataArray.quantity
                            tempDecoData.decorationDetails = { ...tempDecoData.decorationDetails, product: { ...tempDecoData.decorationDetails.product, quanity: dataArray.quantity, quantity: dataArray.quantity } }
                            promises.push(catalogueAPIUtil.updateOrderItemRowDecoration(tempDecoData, quoteId, Itemid, itemArray.id))
                        })
                    }
                }
            })
        }
    })
    let oldRowsIDs = [];
    await data.map(async dataArray => {
        if (dataArray.id != "" && dataArray.id > 0) {
            if (dataArray.decoration && dataArray.decoration.length > 0) {
                if (artworkList) {
                    dataArray.decoration.map(decoArray => {
                        if (decoArray.locationId != "" && decoArray.artworkID != "" && decoArray.variationUniqID != "") {
                            let artwork_selected = artworkList.filter(artworkArray => artworkArray.id === decoArray.artworkID)[0]
                            if (artwork_selected) {
                                promises.push(catalogueAPIUtil.createOrderItemRowDecoration(
                                    [{
                                        "vendor": {
                                            "name": artwork_selected.design.decoVendorName,
                                            "no": artwork_selected.design.decoVendorNo,
                                            "id": artwork_selected.design.decoVendorId
                                        },
                                        "type": artwork_selected.design.designType,
                                        "design": {
                                            "no": artwork_selected.designNo,
                                            "name": artwork_selected.designTypeName,
                                            "customerId": artwork_selected.customerId,
                                            "designVariationId": decoArray.variationUniqID
                                        },
                                        "status": "Pending",
                                        "images": {
                                            "design": [artwork_selected.design.designImages && artwork_selected.design.designImages[0]],
                                        },
                                        "customerDescription": "",
                                        "vendorDescription": "",
                                        "notes": "",
                                        "location": decoArray.location,
                                        "quantity": dataArray.quantity,
                                        "price": "",
                                        "totalPrice": "",
                                        "cost": "",
                                        "totalCost": "",
                                        "profit": "",
                                        "costStrategy": "MANUAL",
                                        "priceStrategy": "MANUAL",
                                        "poType": "",
                                        "tax": "",
                                        "disableTax": "0",
                                        "vouchingStatus": "Pending",
                                        "decorationDetails": {
                                            "product": {
                                                "code": quoteProductDetails.id,
                                                "no": "",
                                                "name": quoteProductDetails.productName,
                                                "quantity": dataArray.quantity,
                                                "size": dataArray.size,
                                                "color": dataArray.color
                                            },
                                            "decoLogoSize": "",
                                            "description": "",
                                            "color": "",
                                            "images": [artwork_selected.design.designImages && artwork_selected.design.designImages[0]],
                                            "variationUniqueId": decoArray.variationUniqID
                                        }
                                    }], quoteId, Itemid, dataArray.id))
                            }
                        }
                    })
                }
            }
        }
    })
    await data.map(async dataArray => {
        if (dataArray.id == "" && dataArray.quantity != "" && Number(dataArray.quantity) > 0 && dataArray.size != "" && dataArray.color != "") {
            let itm = quoteItem.items.filter(itemArray => itemArray.id === Itemid)[0]
            let itmrows = itm.rows;
            let decorow = null;
            let checkDecoration = itmrows && itmrows.filter(itemArray => (itemArray.id === dataArray.refrenceRowID))
            if (itmrows && itmrows.length > 0 && checkDecoration.length > 0 && checkDecoration[0].decoration && checkDecoration[0].decoration.length > 0) {
                itmrows && itmrows.forEach(row => {
                    if (row.id && oldRowsIDs.indexOf(row.id) === -1) {
                        oldRowsIDs.push(row.id)
                    }
                });
                decorow = { ...itmrows.filter(itemArray => (itemArray.id === dataArray.refrenceRowID))[0] };
                decorow.id = "";
                decorow.size = dataArray.size;
                decorow.sku = dataArray.sku;
                decorow.price = dataArray.price;
                decorow.color = dataArray.color;
                decorow.image = dataArray.image;
                decorow.quantity = dataArray.quantity;
                decorow.totalCost = "";
                decorow.totalPrice = "";
                decorow.is_new = true;
            } else {
                let temp_deco = dataArray.decoration;
                if (temp_deco) {
                    temp_deco.map(tempArrayDeco => {
                        tempArrayDeco.quantity = dataArray.quantity;
                        tempArrayDeco.price = '';
                    })
                }
                decorow = {
                    'id': '',
                    "size": dataArray.size,
                    "decoration": dataArray.decoration ? dataArray.decoration : null,
                    "image": dataArray.image,
                    "color": dataArray.color,
                    "quantity": dataArray.quantity,
                    "price": dataArray.price,
                    "totalPrice": '',
                    "cost": "",
                    "poType": quoteProductDetails.poType,
                    "product": {
                        "sku": dataArray.product.sku
                    },
                    "disableTax": 0,
                    "warehouse": 0,
                    "fulfillments": [
                        {
                            "quantity": 1,
                            "type": quoteProductDetails.poType,
                            "status": "",
                            "sourceWarehouse": 1,
                            "incomingWarehouse": 0,
                            "inventoryReceived": 0,
                            "inventoryReceivedQty": 0,
                            "custInventoryReceived": 0,
                            "custInventoryReceivedQty": 0
                        }
                    ]
                }
            }
            if (decorow) {
                promises_first.push(catalogueAPIUtil.createOrderItemRow([decorow], quoteId, Itemid).then((res) => {
                    if (res.data.status == "success" && dataArray.setDecoration) {
                        if (dataArray.setDecoration == "Yes") {
                            let newRId = res.data.data.filter(rowData => compareData(rowData, decorow, oldRowsIDs));
                            if (newRId && newRId[0]) {
                                decorow.decoration.map(dataArray => {
                                    oldRowsIDs.push(newRId[0].id)
                                    dataArray.id = "";
                                    dataArray.quantity = dataArray.quantity;
                                    dataArray.price = ""
                                    dataArray.cost = ""
                                    if (dataArray.decorationDetails)
                                        dataArray.decorationDetails = { ...dataArray.decorationDetails, product: { ...dataArray.decorationDetails.product, quantity: dataArray.quantity }, id: "", itemRowId: null }
                                    promises.push(catalogueAPIUtil.createOrderItemRowDecoration([dataArray], quoteId, Itemid, newRId[0].id))
                                })
                            }
                        } else {
                            if (dataArray.decoration && dataArray.decoration.length > 0) {
                                if (artworkList) {
                                    let newRId = res.data.data.filter(rowData => compareData(rowData, decorow, oldRowsIDs));
                                    if (newRId && newRId[0]) {
                                        oldRowsIDs.push(newRId[0].id)
                                        dataArray.id = "";
                                        dataArray.decoration.map(decoArray => {
                                            if (decoArray.locationId != "" && decoArray.artworkID != "" && decoArray.variationUniqID != "") {
                                                let artwork_selected = artworkList.filter(artworkArray => artworkArray.id === decoArray.artworkID)[0]
                                                if (artwork_selected) {
                                                    promises.push(catalogueAPIUtil.createOrderItemRowDecoration(
                                                        [{
                                                            "vendor": {
                                                                "name": artwork_selected.design.decoVendorName,
                                                                "no": artwork_selected.design.decoVendorNo,
                                                                "id": artwork_selected.design.decoVendorId
                                                            },
                                                            "type": artwork_selected.design.designType,
                                                            "design": {
                                                                "no": artwork_selected.designNo,
                                                                "name": artwork_selected.designTypeName,
                                                                "customerId": artwork_selected.customerId,
                                                                "designVariationId": decoArray.variationUniqID
                                                            },
                                                            "status": "Pending",
                                                            "images": {
                                                                "design": [artwork_selected.design.designImages && artwork_selected.design.designImages[0]],
                                                            },
                                                            "customerDescription": "",
                                                            "vendorDescription": "",
                                                            "notes": "",
                                                            "location": decoArray.location,
                                                            "quantity": dataArray.quantity,
                                                            "price": "",
                                                            "totalPrice": "",
                                                            "cost": "",
                                                            "totalCost": "",
                                                            "profit": "",
                                                            "costStrategy": "MANUAL",
                                                            "priceStrategy": "MANUAL",
                                                            "poType": "",
                                                            "tax": "",
                                                            "disableTax": "0",
                                                            "vouchingStatus": "Pending",
                                                            "decorationDetails": {
                                                                "product": {
                                                                    "code": quoteProductDetails.id,
                                                                    "no": "",
                                                                    "name": quoteProductDetails.productName,
                                                                    "quantity": dataArray.quantity,
                                                                    "size": dataArray.size,
                                                                    "color": dataArray.color
                                                                },
                                                                "decoLogoSize": "",
                                                                "description": "",
                                                                "color": "",
                                                                "images": [artwork_selected.design.designImages && artwork_selected.design.designImages[0]],
                                                                "variationUniqueId": decoArray.variationUniqID
                                                            }
                                                        }], quoteId, Itemid, newRId[0].id))
                                                }
                                            }
                                        })
                                    }
                                }
                            }
                        }
                    } else if (res.data.status == "success") {
                        let newRId = res.data.data.filter(rowData => compareData(rowData, decorow, oldRowsIDs));
                        if (newRId && newRId[0] && decorow.is_new) {
                            decorow && decorow.decoration && decorow.decoration.map(dataArrayFilter => {
                                oldRowsIDs.push(newRId[0].id)
                                dataArrayFilter.id = "";
                                dataArrayFilter.quantity = decorow.quantity
                                dataArrayFilter.price = ""
                                dataArrayFilter.cost = ""
                                dataArrayFilter.decorationDetails = { ...dataArrayFilter.decorationDetails, product: { ...dataArrayFilter.decorationDetails.product, quantity: decorow.quantity }, id: "", itemRowId: null }
                                promises.push(catalogueAPIUtil.createOrderItemRowDecoration([dataArrayFilter], quoteId, Itemid, newRId[0].id))
                            })

                        } else {
                            if (dataArray.decoration && dataArray.decoration.length > 0) {
                                if (artworkList) {
                                    let newRId = res.data.data.filter(rowData => compareData(rowData, decorow, oldRowsIDs));
                                    if (newRId && newRId[0]) {
                                        oldRowsIDs.push(newRId[0].id)
                                        dataArray.id = "";
                                        dataArray.decoration.map(decoArray => {
                                            if (decoArray.locationId != "" && decoArray.artworkID != "" && decoArray.variationUniqID != "") {
                                                let artwork_selected = artworkList.filter(artworkArray => artworkArray.id === decoArray.artworkID)[0]
                                                if (artwork_selected) {
                                                    promises.push(catalogueAPIUtil.createOrderItemRowDecoration(
                                                        [{
                                                            "vendor": {
                                                                "name": artwork_selected.design.decoVendorName,
                                                                "no": artwork_selected.design.decoVendorNo,
                                                                "id": artwork_selected.design.decoVendorId
                                                            },
                                                            "type": artwork_selected.design.designType,
                                                            "design": {
                                                                "no": artwork_selected.designNo,
                                                                "name": artwork_selected.designTypeName,
                                                                "customerId": artwork_selected.customerId,
                                                                "designVariationId": decoArray.variationUniqID
                                                            },
                                                            "status": "Pending",
                                                            "images": {
                                                                "design": [artwork_selected.design.designImages && artwork_selected.design.designImages[0]],
                                                            },
                                                            "customerDescription": "",
                                                            "vendorDescription": "",
                                                            "notes": "",
                                                            "location": decoArray.location,
                                                            "quantity": dataArray.quantity,
                                                            "price": "",
                                                            "totalPrice": "",
                                                            "cost": "",
                                                            "totalCost": "",
                                                            "profit": "",
                                                            "costStrategy": "MANUAL",
                                                            "priceStrategy": "MANUAL",
                                                            "poType": "",
                                                            "tax": "",
                                                            "disableTax": "0",
                                                            "vouchingStatus": "Pending",
                                                            "decorationDetails": {
                                                                "product": {
                                                                    "code": quoteProductDetails.id,
                                                                    "no": "",
                                                                    "name": quoteProductDetails.productName,
                                                                    "quantity": dataArray.quantity,
                                                                    "size": dataArray.size,
                                                                    "color": dataArray.color
                                                                },
                                                                "decoLogoSize": "",
                                                                "description": "",
                                                                "color": "",
                                                                "images": [artwork_selected.design.designImages && artwork_selected.design.designImages[0]],
                                                                "variationUniqueId": decoArray.variationUniqID
                                                            }
                                                        }], quoteId, Itemid, newRId[0].id))
                                                }
                                            }
                                        })
                                    }
                                }
                            }
                        }
                    }
                }))
            }
        }
    })
    Promise.all(promises_first).then(values => {
        Promise.all(promises).then(values => {
            addToast("Item(s) updated!", {
                appearance: "success",
                autoDismiss: true
            });
            dispatch(fetchQuote(quoteId));
            dispatch(fetchQuoteItemDetails(quoteId, Itemid));
            dispatch(fetchQuoteItemRows(quoteId, Itemid));
            dispatch(setSaveBtn(false, []))
            setLoader(false);
        }).catch(error => {
            addToast("Item(s) not updated!", {
                appearance: "error",
                autoDismiss: true
            });
            setLoader(false);
            dispatch(isLoading(false));
            dispatch(sendFetchError());
            return false;
        });
    }).catch(error => {
        addToast("Item(s) not updated!", {
            appearance: "error",
            autoDismiss: true
        });
        setLoader(false);
        dispatch(isLoading(false));
        dispatch(sendFetchError());
        return false;
    });
}
export const updateRowItem = (qid, id, data) => dispatch => catalogueAPIUtil.updateRowItem(qid, id, data)
    .then(res => {
        return true;
    }).catch(error => {
        setLoader(false);
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });
export const isLoading = (loading: boolean) => ({
    type: IS_LOADING,
    loading
});
export const setLoader = (loaderOnly: boolean) => ({
    type: IS_LOADER,
    loaderOnly
});
export const setSelectedItems = (items) => ({
    type: SET_ITEMS_SELECTED,
    items: items
});

export const sendFetchError = () => ({
    type: FETCH_ERROR
});

export const clearFilters = (statuses: string[]) => ({
    type: CLEAR_FILTERS,
    payload: statuses
});
export const clearQuoteDetailData = () => ({
    type: CLEAR_QUOTE_DETAIL_DATA,
});
export const setSaveBtn = (btn, changeOnItems) => ({
    type: SET_SAVE_BTN,
    payload: btn,
    changeOnItems: changeOnItems
});

export const receiveFilterUpdate = (filter: { [key: string]: any }) => ({
    type: UPDATE_FILTERS,
    payload: filter,
});
export const fetchArtworks = (filterData) => dispatch => catalogueAPIUtil.fetchArtworks(filterData)
    .then(res => {
        const artworks: MArtwork[] = res.data.data.map(individualOrder => {
            return new MArtwork(individualOrder);
        });
        dispatch(isLoading(false));
        dispatch(receiveArtworks(artworks))
    }).catch(error => {
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });
export const receiveArtworks = (artworks: IArtwork[]) => ({
    type: RECEIVE_QARTWORKS_LIST,
    payload: artworks,
});
export const receiveDecoratorVendors = (types) => ({
    type: RECEIVE_QUOTE_DECORATORS_VENDORS_LIST,
    payload: types,
});
export const getDecoratorVendors = () => dispatch => catalogueAPIUtil.getDecoratorVendors()
    .then(res => {
        dispatch(isLoading(false));
        dispatch(receiveDecoratorVendors(res.data))
    }).catch(error => {
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });
export const receiveDecorationType = (types: []) => ({
    type: RECEIVE_QUOTE_DECORATION_TYPE,
    payload: types,
});
export const fetchDecorationTypes = () => dispatch => catalogueAPIUtil.fetchDecorationTypes()
    .then(res => {
        dispatch(receiveDecorationType(res.data))
    }).catch(error => {
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });
export const receiveDecoratorTypes = (types) => ({
    type: RECEIVE_QUOTE_DECORATORS_TYPE_LIST,
    payload: types,
});
export const getDecoratorTypes = () => dispatch => catalogueAPIUtil.getDecoratorTypes()
    .then(res => {
        dispatch(isLoading(false));
        dispatch(receiveDecoratorTypes(res.data))
    }).catch(error => {
        dispatch(isLoading(false));
        dispatch(sendFetchError());
    });

export const getQuoteContentDetail = (quoteId) => dispatch => quoteAPIUtil.fetchQuoteContentDetail(quoteId)
    .then(res => {
      const quotes = res.data;
      let tempQuote = JSON.stringify(quotes)
      tempQuote = tempQuote.replace(new RegExp('cdnl.sanmar.com', 'g'), 'cdnm.sanmar.com')
      dispatch(receiveQuoteContent(JSON.parse(tempQuote)))
    }).catch(error => {
        dispatch(sendFetchError());
    }).finally(() => dispatch(isLoading(false)));
